<template>
	<div>
		<h1 class="text-center">
			403	Forbidden
		</h1>
	</div>
</template>

<script>
export default {
	page: {
		title: '403',
		meta: [{ name: 'description', content: '403' }]
	}
}
</script>
